import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface IntegrationDeletionModalProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  integrationName: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  loading?: boolean;
  className?: string;
}

function IntegrationDeletionModal({
  open,
  onOpenChange,
  integrationName,
  onConfirm,
  onCancel,
  loading = false,
  className,
}: IntegrationDeletionModalProps) {
  const handleCancel = () => {
    onCancel?.();
    onOpenChange?.(false);
  };

  const handleConfirm = () => {
    onConfirm?.();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className={cn(
            "max-w-[479px] w-full p-0 gap-0 rounded-lg border border-gray-300 bg-white overflow-hidden",
            className,
          )}
        >
          {/* Header */}
          <div className="flex items-center px-6 pt-6 pb-4 bg-white rounded-t-lg">
            <h2 className="text-lg font-semibold leading-snug text-gray-800 m-0">
              Disconnect {integrationName} Account?
            </h2>
          </div>

          {/* Content */}
          <div className="flex flex-col px-6 pb-6 gap-5 bg-white rounded-b-lg">
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-1">
                <p className="text-base font-normal leading-relaxed text-gray-800 m-0">
                  New calls will stop being scored. All your data and settings
                  will be preserved, and you can reconnect the {integrationName}{" "}
                  account at any time.
                </p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-3">
              <Button
                intent="danger"
                variant="solid"
                size="md"
                onClick={handleConfirm}
                disabled={loading}
                className="px-5 py-3"
              >
                {loading ? "Disconnecting..." : "Yes, Disconnect"}
              </Button>
              <Button
                intent="secondary"
                variant="solid"
                size="md"
                onClick={handleCancel}
                disabled={loading}
                className="px-6 py-2.5"
              >
                Nevermind
              </Button>
            </div>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}

export { IntegrationDeletionModal };
export type { IntegrationDeletionModalProps };
